/* src/app/views/display/components/modals/edit-specific-date-time-modal/edit-specific-date-time-modal.component.scss */
.date-time-windows-container {
  border-bottom: 1px solid #dadbde;
  padding-inline: 0.2rem;
}
.recurring-details-container {
  padding-inline: 0.2rem;
}
/*# sourceMappingURL=edit-specific-date-time-modal.component.css.map */
